<div class="row g-10">
  <!--begin::Hot sales post-->
  <ng-container *ngIf="data; else noData">
    <ng-container *ngFor="let cat of data ">
      <!--begin::Col-->
      <div class="col-md-4">
      
        <lcms-simple-card1 [catalogue]="cat"></lcms-simple-card1>
        <!--end::Hot sales post-->
      </div>
    </ng-container>
  </ng-container>
  <ng-template #noData> 
    <div class="spinner-grow" role="status">
      <span class="sr-only">Loading...</span>
    </div>
   </ng-template>

  <!--end::Col-->
</div>
